import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    admin: "",

    url: "https://equb.virtualbet1.com/graphql",
  },
  getters: {},
  mutations: {
    loginAdmin(state, admin) {
      state.admin = admin;
    },
  },
  actions: {
    loginAdmin(context, admin) {
      context.commit("loginAdmin", admin);
    },
  },

  plugins: [createPersistedState()],
  modules: {},
});
